export const resolveInTimeout = (duration: number) =>
  new Promise((resolve) =>
    setTimeout(() => {
      resolve({ finished: true });
    }, duration)
  );
